import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import {ROUTES} from '@/config/routesConstants';
import NavLink from '@/components/nav-link';
import Page from '@/components/page';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';
import useToken from '@/hooks/use-token';
import translate from '../../utils/translate';
import styles from './Preferences.module.scss';

const StyledNavLink = styled(NavLink)(() => ({
  color: designSystemToken('semantic.fg.neutral'),
  height: '30px',
}));

const activeStyle = () => ({
  boxShadow: `inset 0 -3px 0 0 ${designSystemToken('semantic.bg.brand')}`,
  color: `${designSystemToken('semantic.fg.brand')} !important`,
});

function Preferences({basePath = ROUTES.PREFERENCES}: {basePath?: string}) {
  const {isAuthenticated} = useToken(true);
  const {dashboardUser} = useDashboardUserQuery({
    enabled: isAuthenticated,
  });

  const isAdmin = dashboardUser?.isAdmin;
  const TRANSLATION_PREFIX = 'components.preferences';
  const location = useLocation();

  return (
    <Page
      id="preferences"
      className={styles.container}
      childrenClassName={styles.content}
    >
      <div>
        <nav className={styles.tabNavigation}>
          <StyledNavLink
            to={`${basePath}/account`}
            style={({isActive}) =>
              isActive || location.pathname === basePath
                ? activeStyle()
                : undefined
            }
          >
            {translate(`${TRANSLATION_PREFIX}.tabs.account`)}
          </StyledNavLink>
          {!isAdmin && (
            <StyledNavLink
              to={`${basePath}/notifications`}
              style={({isActive}) => (isActive ? activeStyle() : undefined)}
            >
              {translate(`${TRANSLATION_PREFIX}.tabs.notifications`)}
            </StyledNavLink>
          )}
          <StyledNavLink
            to={`${basePath}/terms-of-service`}
            style={({isActive}) =>
              isActive || ['/terms-of-service'].includes(location.pathname)
                ? activeStyle()
                : undefined
            }
          >
            {translate(`${TRANSLATION_PREFIX}.tabs.terms-of-service`)}
          </StyledNavLink>
        </nav>
        <Outlet />
      </div>
    </Page>
  );
}

export default Preferences;
